import styled from '@emotion/styled/macro';
import { css } from '@emotion/core';

export const CheckBox = styled.div`
  align-items: center;
  border-radius: 50%;
  border: 0.2rem solid ${({ theme }) => theme.colors['greyish-brown-two']};
  cursor: pointer;
  display: flex;
  height: 2rem;
  justify-content: center;
  position: relative;
  transition: all 0.1s;
  width: 2rem;

  &::after {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    content: '';
    display: block;
    height: 1.1rem;
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1.1rem;
  }

  ${({ checked, theme }) =>
    checked &&
    css`
      border-color: ${theme.colors.primary};
      &::after {
        opacity: 1;
      }
    `}
`;
